import { Link } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";

export default function Dashboard({ onLogout }) {
  return (
     <>
     <AdminNavbar onLogout={onLogout} />
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Dashboard</h1>
        <button className="btn btn-danger" onClick={onLogout}>
          Logout
        </button>
      </div>
      <div className="list-group">
        <Link to="/admin/banners" className="list-group-item list-group-item-action">
          Manage Banners
        </Link>
        <Link to="/admin/banners/add" className="list-group-item list-group-item-action">
          Add Banner
        </Link>
      </div>
    </div>
    </>
  );
}
